import reduxStore from "../configureEnvStore";
import { ENABLED } from "../constants/Constants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import { setShowLocationPermissionPopup } from "../reducers/common-reducer";
import { LogFirebase } from "../services/firestore";

export const checkGeolocationPermission = () => {
    return new Promise((resolve, reject) => {
        if (navigator.permissions?.query) {
            navigator.permissions.query({ name: "geolocation" }).then(function (result) {
                if (result.state === "denied") {
                    /* if the location is block by the guest then show a modal */
                    if (GLOBAL_MEETING_DATA.isGuest) {
                        reduxStore.dispatch(setShowLocationPermissionPopup(true));
                        PublicVariables.allowedLocation = false;
                        LogFirebase("PERMISSION", "LOCATION_PERMISSION", "denied");
                    }
                    reject(result);
                } else {
                    resolve();
                }
            });
        } else {
            resolve();
        }
    });
};

export const getCurrentPosition = () => {
    return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
    });
};

export const getUpdatedCoordinates = () => {
    return new Promise((resolve, reject) => {
        const isConnected = reduxStore.getState().commonReducer.isRemoteParticipantJoined;
        if (isConnected && PublicVariables.featureFlag.ENABLELOCATION === ENABLED && navigator.geolocation !== undefined) {
            const options = {
                enableHighAccuracy: true,
                timeout: 1000,
                maximumAge: 3600000,
            };

            PublicVariables.objWatchPositionId = navigator.geolocation.watchPosition(
                function (position) {
                    let results = {
                        success: 1,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    };
                    resolve(results);
                },
                function (error) {
                    let results = {
                        success: 0,
                        latitude: 0,
                        longitude: 0,
                    };
                    console.error("Geolocation error:", error);
                    reject(results);
                },
                options
            );
        } else {
            let results = {
                success: 0,
                latitude: 0,
                longitude: 0,
            };
            reject(results);
        }
    });
};
